import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { light } = theme.palette.primary;

  return {
    header: {
      borderBottom: `1px solid ${light}`,
      padding: "0 4px 0 20px",
      "& .MuiTypography-root": {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 57
      },
      "& .MuiSvgIcon-root": {
        width: 26,
        height: 26
      }
    },
    title: {
      fontSize: 20,
      [theme.breakpoints.down(Breakpoints.SS_320)]: {
        fontSize: 18
      }
    }
  };
});
